/**
 * Modifier-group selection rule helpers (Step 2 extraction).
 *
 * `modifierGroupRules` lived inline in StandardOrder.vue and was passed down as
 * a function-prop to ModifierPanel. It is pure (group in, {required, text} out)
 * and never touches Vuex or `this`, so it lives here and is unit-tested in
 * isolation. The returned strings are kept byte-identical to the legacy code
 * (note the en-dash in the "Select min–max" form).
 *
 * @param {object} modifierGroup
 * @returns {{ required: boolean, selectionText: string }}
 */
export function getModifierGroupRules(modifierGroup) {
  const min = Number(modifierGroup?.min_selection) || 0;
  const max = Number(modifierGroup?.max_selection) || 0;

  const required = min > 0;

  let selectionText = "Select any";
  if (min > 0 && max > 0) {
    selectionText = (min === max) ? `Select exactly ${min}` : `Select ${min}–${max}`;
  } else if (min > 0) {
    selectionText = `Select at least ${min}`;
  } else if (max > 0) {
    selectionText = `Select up to ${max}`;
  }

  return { required, selectionText };
}
